import '.du{font-size:1.125rem;}.ssr-plugin'
import '.ei{line-height:1.75rem;}.ssr-plugin'
import '.hy{text-decoration:none;}.ssr-plugin'
import '.fy{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="du ei"
    >
      {translations.privacySubtitle}{' '}
      <a className="hy fy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="hy fy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
